import * as React from 'react';

function SvgPhone(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M512 370.992v80.419c0 34.982-28.562 60.314-60.033 60.314-115.816 0-228.805-54.752-312.842-138.454C55.087 289.568 0 176.915 0 61.098 0 27.831 27.06 1.065 60.314 1.065h80.419c8.658 0 16.338 5.536 19.059 13.739l40.21 120.346a20.12 20.12 0 01-2.332 17.518l-34.098 51.16c12.921 27.101 35.786 56.722 62.191 82.805 26.417 26.069 56.373 48.6 83.474 61.52l51.16-34.097c5.187-3.418 11.621-4.316 17.518-2.333l120.628 40.21c8.203 2.721 13.457 10.401 13.457 19.059z"
        fill="#FF641A"
      />
      <path
        d="M512 370.992v80.419c0 34.982-28.562 60.314-60.033 60.314-115.816 0-228.805-54.752-312.842-138.454l86.638-86.638c26.417 26.069 56.373 48.6 83.474 61.52l51.16-34.097c5.187-3.418 11.621-4.316 17.518-2.333l120.628 40.21c8.203 2.721 13.457 10.401 13.457 19.059z"
        fill="#F03800"
      />
    </svg>
  );
}

export default SvgPhone;
